// import { motion } from "framer-motion";
// import { ArrowRight, Phone } from "lucide-react";

// export default function HomeCTA() {
//   return (
//     <section
//       style={{
//         background:
//           "linear-gradient(180deg, #f8fafc 0%, #e8eef9 40%, #1a2342 100%)",
//         padding: "90px 20px 100px",
//         position: "relative",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "1100px",
//           margin: "0 auto",
//           display: "grid",
//           gridTemplateColumns: "1.2fr 0.8fr",
//           gap: "50px",
//           alignItems: "center",
//         }}
//       >
//         {/* LEFT CONTENT */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//         >
//           <span
//             style={{
//               display: "inline-block",
//               background: "rgba(79,70,229,0.12)",
//               color: "#1e3a8a",
//               padding: "8px 14px",
//               borderRadius: "6px",
//               fontSize: "13px",
//               letterSpacing: "1px",
//               marginBottom: "16px",
//               fontWeight: 600,
//             }}
//           >
//             LET’S BUILD SOMETHING IMPACTFUL
//           </span>

//           <h2
//             style={{
//               fontSize: "40px",
//               fontWeight: "700",
//               lineHeight: "1.25",
//               marginBottom: "16px",
//               color: "#0f172a",
//             }}
//           >
//             Turn Your Idea Into a <br /> Scalable Digital Product
//           </h2>

//           <p
//             style={{
//               fontSize: "17px",
//               color: "#334155",
//               maxWidth: "560px",
//               lineHeight: "1.7",
//             }}
//           >
//             Whether you're launching a startup or modernizing an enterprise
//             system, INFRONEX delivers secure, scalable, and future-ready
//             software solutions.
//           </p>
//         </motion.div>

//         {/* RIGHT CARD */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6, delay: 0.15 }}
//           style={{
//             background: "rgba(255,255,255,0.96)",
//             borderRadius: "16px",
//             padding: "38px",
//             boxShadow: "0 20px 50px rgba(15,23,42,0.25)",
//           }}
//         >
//           <h3
//             style={{
//               fontSize: "22px",
//               fontWeight: "600",
//               marginBottom: "10px",
//               color: "#0f172a",
//             }}
//           >
//             Start a Conversation
//           </h3>

//           <p
//             style={{
//               fontSize: "15px",
//               color: "#475569",
//               marginBottom: "26px",
//             }}
//           >
//             Tell us about your project and get expert guidance within 24 hours.
//           </p>

//           <div style={{ display: "flex", gap: "14px", flexWrap: "wrap" }}>
//             <a
//               href="/contact"
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 background: "#1e3a8a",
//                 color: "white",
//                 padding: "14px 26px",
//                 borderRadius: "8px",
//                 fontWeight: "600",
//                 textDecoration: "none",
//                 boxShadow: "0 10px 25px rgba(30,58,138,0.35)",
//               }}
//             >
//               Get Free Consultation <ArrowRight size={18} />
//             </a>

//             <a
//               href="/contact"
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 border: "1px solid #1e3a8a",
//                 color: "#1e3a8a",
//                 padding: "14px 22px",
//                 borderRadius: "8px",
//                 fontWeight: "500",
//                 textDecoration: "none",
//                 background: "white",
//               }}
//             >
//               <Phone size={16} /> Contact Sales
//             </a>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function HomeCTA() {
  return (
    <section className="bg-white py-20 px-6 relative overflow-hidden border-t border-slate-100 font-inter">
      {/* Professional subtle mesh gradient background */}
      <div className="absolute inset-0 z-0 opacity-[0.4] pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full"
          style={{
            backgroundImage: `radial-gradient(circle at 50% -20%, #f1f5f9 0%, transparent 70%)`,
          }}
        />
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center relative z-10">
        {/* LEFT CONTENT */}
        <motion.div
          className="lg:col-span-7"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-[1px] bg-indigo-500"></div>
            <span className="text-[11px] font-bold tracking-[0.15em] text-indigo-600 uppercase">
              Partnership
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-[1.15] mb-4 tracking-tight">
            Engineering your <br />
            <span className="text-slate-500 font-medium">digital future.</span>
          </h2>

          <p className="text-[15px] text-slate-500 max-w-md leading-relaxed">
            Infronex partners with ambitious companies to build scalable
            software, cloud infrastructure, and seamless digital experiences.
          </p>
        </motion.div>

        {/* RIGHT CARD */}
        <motion.div
          className="lg:col-span-5 bg-[#fcfcfd] border border-slate-200/60 p-7 md:p-8 rounded-2xl shadow-sm"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <h3 className="text-lg font-semibold text-slate-900 mb-2">
            Connect with us
          </h3>
          <p className="text-sm text-slate-500 mb-6">
            Get expert technical guidance for your next project.
          </p>

          <div className="flex flex-col gap-3">
            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition-all shadow-sm"
            >
              Consult an Expert <ArrowRight size={16} />
            </Link>

            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 border border-slate-200 hover:bg-slate-50 text-slate-700 px-5 py-2.5 rounded-lg text-sm font-medium transition-all"
            >
              <Phone size={14} /> Contact Sales
            </Link>
          </div>

          <div className="flex items-center justify-center gap-4 mt-6 pt-6 border-t border-slate-100">
            <div className="flex -space-x-2">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="w-6 h-6 rounded-full bg-slate-200 border-2 border-white"
                />
              ))}
            </div>
            <p className="text-[11px] text-slate-400 font-medium uppercase tracking-wider">
              Trusted by 50+ Enterprises
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}